import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Button,
    Grid,
    TableContainer,
    Divider,
    Typography,
} from '@material-ui/core';
import moment from 'moment';
import { useStylesAuth } from '../../../../../styles/auth/style';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: 70,
    },
    align: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    alignDatos: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        width: '100%',
        border: '1px solid #ccc',
        borderRadius: '.3em',
        textAlign: 'center',
    },
    textObservaciones: {
        width: '100%',
        border: '1px solid #ccc',
        borderRadius: '.5em',
        //textAlign: 'left',
        padding: '1em',
        wordBreak: 'break-word',
        textAlign: 'justify',
    },
    paragraphSpacing: {
        marginTop: '0em', // Ajusta el espacio entre párrafos según tus preferencias
    },
    textJustified: {
        textAlign: 'justify', // Aplica justificación al texto
    },
}));

export const FormatoImpresionInformeOftalmo = ({
    handleClose,
    handlePrintRow,
    componentRef,
    modal,
    informe,
}) => {

    const classes = useStyles();
    const classesAuth = useStylesAuth('light');
    const { dataAfiliado } = useSelector((state) => state.hce);

    return (
        <>
            <TableContainer className={classes.form}>
                <Grid container spacing={2} ref={componentRef}>
                    <Grid item xs={12} className={classes.logo}>
                        <Grid container justify="flex-end">
                            <Grid item xs={6} className={classesAuth.imageInherit} />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: '1em' }}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container>
                            <Grid container>
                                <Grid item xs={12} className={classes.align}>
                                    <Typography style={{ fontSize: '1.5em' }} color="primary">
                                        Fecha de Impresion: {moment().format('DD/MM/YYYY')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} className={classes.align}>
                                    <Typography style={{ fontSize: '1.5em' }} color="primary">
                                        Informe Nro: {informe?.id}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '2em' }}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: 'center' }}>
                        <Grid
                            container
                            spacing={2}
                            justify="space-evenly"
                            alignItems="flex-end"
                        >
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Fecha de Informe:</Typography>
                                <Typography variant="overline" className={classes.text}>
                                    {moment(informe?.fechaIngreso).format('DD/MM/YYYY')}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Nro Afiliado:</Typography>
                                <Typography variant="overline" className={classes.text}>
                                    {dataAfiliado?.carnet}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Nombre y Apellido:</Typography>
                                <Typography variant="overline" className={classes.text}>
                                    {dataAfiliado?.apellido_y_nombre}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Nombre Informe:</Typography>
                                <Typography variant="overline" className={classes.text}>
                                    {informe?.nombreInforme}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Profesional:</Typography>
                                <Typography variant="overline" className={classes.text}>
                                    {informe?.nombreMedico}
                                </Typography>
                            </Grid>
                            <Grid item xs={4} className={classes.alignDatos}>
                                <Typography>Especialidad:</Typography>
                                <Typography variant="overline" className={classes.text}>
                                    {informe?.descripcionEspecialidad}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '2em' }}>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} className={classes.alignDatos}>
                        <Typography>Detalle Informe:</Typography>
                        <Typography
                            variant="overline"
                            className={`${classes.textObservaciones} ${classes.textJustified}`}
                        >
                            {informe?.informe.split('\n').map((paragraph, index) => (
                                <span key={index}>
                                    {paragraph}
                                    {index !== informe?.informe.split('\n').length - 1 && (
                                        <br className={classes.paragraphSpacing} />
                                    )}
                                </span>
                            ))}
                        </Typography>
                    </Grid>
                </Grid>
                {modal && (
                    <Grid
                        item
                        xs={12}
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            marginTop: '1em',
                        }}
                    >
                        <Button
                            style={{ marginRight: 5 }}
                            onClick={handleClose}
                            variant="contained"
                            color="primary"
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handlePrintRow}
                            variant="contained"
                            color="primary"
                            autoFocus
                        >
                            Imprimir
                        </Button>
                    </Grid>
                )}
            </TableContainer>
        </>
    );
};
